export function planUsageAdaptor(planUsageData) {
  const currentPlanFeaturesRaw = planUsageData?.data?.currentPlanFeatures || [];
  const currentPlanFeatureKeys = currentPlanFeaturesRaw.map((x) => x?.feature?.key).filter(Boolean);

  // feature key -> cheapest plan name that includes it (backend-computed). Lets
  // the create flow show the feature-correct required plan (e.g. Prime for BOGO)
  // instead of the static "next plan up".
  const featureMinPlan = planUsageData?.data?.featureMinPlan || {};

  const getPermissionsFake = {
    data: {
      currentPlan: {
        currentPlanId: planUsageData?.data?.currentPlan?.id,
        currentPlanPeriod: planUsageData?.data?.currentPlanPeriod === 'monthly' ? 0 : 1,
        currentPlanDate: planUsageData?.data?.currentPlanStartedAt,
        CurrentPlanUser: '',
        plan: {
          id: planUsageData?.data?.currentPlan?.id,
          name: planUsageData?.data?.currentPlan?.name,
          plankey: planUsageData?.data?.currentPlan?.name,
          featureTitleDesciption: planUsageData?.data?.currentPlan?.featureHeader,
          monthlyPrice: planUsageData?.data?.currentPlan?.monthlyPrice,
          annualPrice: planUsageData?.data?.currentPlan?.annualPrice,
          isActive: true,
          isDefaultPlan: false,
          createdDate: '2022-11-29T03:39:08.436Z',
          description: planUsageData?.data?.currentPlan?.description,
          auctionCountLimit: planUsageData?.data?.currentPlan?.maxCampaignsCount,
          auctionProductLimit: planUsageData?.data?.currentPlan?.maxVariantsCount,
          trialDays: planUsageData?.data?.currentPlan?.trialDays,
          features: [],
          top_features: [],
          isRecommended: false,
          order: 5,
          isUnlimitedCampaigns: planUsageData?.data?.currentPlan?.isUnlimitedCampaigns,
          isUnlimitedVariants: planUsageData?.data?.currentPlan?.isUnlimitedVariants,
          maxCountdownCampaigns: planUsageData?.data?.currentPlan?.maxCountdownCampaigns ?? 0,
          isFree: false,
          permissions: [],
          period: planUsageData?.data?.currentPlanPeriod === 'monthly' ? 0 : 1,
        },
      },

      currentPlanFeatures: currentPlanFeaturesRaw,
      currentPlanFeatureKeys,
      featureMinPlan,

      trialEligible: true,
      permissions: {
        can_set_schedule:
          planUsageData?.data?.currentPlan?.permissions?.includes('campaign_start_schedule'),
        can_set_exclude_product: planUsageData?.data?.currentPlan?.permissions?.includes(
          'campaign_exclude_products'
        ),
        can_set_discount_type: planUsageData?.data?.currentPlan?.permissions?.includes(
          'campaign_general_change_mode'
        ),
        can_set_onFly_campaign:
          planUsageData?.data?.currentPlan?.permissions?.includes('campaign_auto_update'),
        can_prevent_shopify_discounts: planUsageData?.data?.currentPlan?.permissions?.includes(
          'prevent_shopify_discount'
        ),
        can_set_quantity_discounts: planUsageData?.data?.currentPlan?.permissions?.includes(
          'campaign_quantity_and_volume_discount'
        ),
        can_set_Tire_discounts: planUsageData?.data?.currentPlan?.permissions?.includes(
          'campaign_quantity_and_volume_discount_add_tier'
        ),
        can_set_tier_order_discounts: planUsageData?.data?.currentPlan?.permissions?.includes(
          'can_set_tier_order_discounts'
        ),
        can_set_order_discounts:
          planUsageData?.data?.currentPlan?.permissions?.includes('can_set_order_discounts'),
        can_set_product_countdown: planUsageData?.data?.currentPlan?.permissions?.includes(
          'can_set_product_countdown'
        ),
        can_set_product_countdown_settings: planUsageData?.data?.currentPlan?.permissions?.includes(
          'can_set_product_countdown_settings'
        ),
        can_set_discount_code_option: planUsageData?.data?.currentPlan?.permissions?.includes(
          'can_set_discount_code_option'
        ),
        can_set_maximum_discount_tier: planUsageData?.data?.currentPlan?.permissions?.includes(
          'can_set_maximum_discount_tier'
        ),
        has_price_rule_scope: true,
        has_discounts_scope: true,
        campaign_quantity_and_volume_discount_theme_extension:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'campaign_quantity_and_volume_discount_theme_extension'
          ),
        can_set_General_Custom_Badge: planUsageData?.data?.currentPlan?.permissions?.includes(
          'can_set_General_Custom_Badge'
        ),
        // Custom wholesale Discount progress bar widget — global settings page
        // (Premium and higher).
        can_set_custom_progress_bar: planUsageData?.data?.currentPlan?.permissions?.includes(
          'can_set_custom_progress_bar'
        ),
        // Per-campaign custom progress bar widget (Prime and higher).
        can_set_campaign_custom_progress_bar: planUsageData?.data?.currentPlan?.permissions?.includes(
          'can_set_campaign_custom_progress_bar'
        ),
        can_set_General_Custom_Badge_settings:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'can_set_General_Custom_Badge_settings'
          ),
        can_set_General_Custom_Badge_per_campaign:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'can_set_General_Custom_Badge_per_campaign'
          ),
        can_set_discount_code_once_per_customer:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'can_set_discount_code_once_per_customer'
          ),
        can_set_widget_custom_css:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'can_set_widget_custom_css'
          ),
        campaign_general_change_mode:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'campaign_general_change_mode'
          ),
        can_use_display_price_advanced:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'can_use_display_price_advanced'
          ),
        can_use_inventory_embed_widget:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'can_use_inventory_embed_widget'
          ),
        can_use_price_protection:
          planUsageData?.data?.currentPlan?.permissions?.includes(
            'can_use_price_protection'
          ),
      },

      canAddCampaign:
        (planUsageData?.data?.campaignUsage || 0) <
          planUsageData?.data?.currentPlan?.maxCampaignsCount ||
        planUsageData?.data?.currentPlan?.isUnlimitedVariants,

      countdownUsage: planUsageData?.data?.countdownUsage ?? { used: 0, max: 0 },
    },
    success: true,
  };

  return getPermissionsFake;
}
